/* eslint-disable no-console */
/* eslint-disable no-alert */
import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function FreeTrialPage() {
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        contactNumber: "",
        profession: "",
        companyName: "",
    });
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const ADMIN_WHATSAPP_NUMBER = process.env.REACT_APP_ADMIN_WHATSAPP || '61450290914'; // Example: '911234567890'
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleWhatsAppSend = () => {
        // Validate required fields
        if (!formData.fullName || !formData.email || !formData.contactNumber || !formData.profession || !formData.companyName) {
            alert('Please fill in all required fields (Name, Email, Service, and Project Details) before sending via WhatsApp.');
            return;
        }

        // Construct the message
        const message = `
*New Enquiry from UniTechnoStack Website*
*fulName:* ${formData.fullName}
*Email:* ${formData.email}
*Phone:* ${formData.contactNumber || 'Not provided'}
*Profession/Title:* ${formData.profession}
*Company:* ${formData.companyName || 'Not provided'}

        `.trim();

        // Encode for URL
        const encodedMessage = encodeURIComponent(message);

        // Create WhatsApp link
        const whatsappLink = `https://wa.me/${ADMIN_WHATSAPP_NUMBER}?text=${encodedMessage}`;

        // Open in new tab
        window.open(whatsappLink, '_blank');
        setSubmitted(true);
    };



    if (submitted) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-green-50 to-white py-20 px-6">
                <div className="max-w-3xl mx-auto bg-white rounded-3xl shadow-2xl p-10 text-center">
                    <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center text-4xl mx-auto">✅</div>
                    <h1 className="mt-6 text-4xl font-bold text-gray-900">Thank You!</h1>
                    <p className="mt-4 text-xl text-gray-600">
                        Your free trial request has been received. A Uniproid representative will contact you within the next few hours.
                    </p>
                    <Link
                        to="/"
                        className="mt-8 inline-block px-8 py-3 bg-indigo-600 text-white rounded-xl hover:bg-indigo-700 transition"
                    >
                        Return Home
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 py-20 px-6">
            <div className="max-w-3xl mx-auto bg-white rounded-3xl shadow-2xl p-10 border border-indigo-100">
                <h1 className="text-4xl font-bold text-gray-900">
                    Start Your 30-Day Free Experience
                </h1>
                <p className="mt-4 text-lg text-gray-600">
                    Fill out the information below. A Uniproid team member will personally reach out to set up your digital identity and answer any questions.
                </p>

                <form onSubmit={handleWhatsAppSend} className="mt-8 space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            Full name <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            name="fullName"
                            required
                            value={formData.fullName}
                            onChange={handleChange}
                            className="mt-1 w-full border border-gray-300 rounded-xl p-3 focus:ring-2 focus:ring-indigo-300 focus:border-indigo-400 outline-none"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            Email address <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="email"
                            name="email"
                            required
                            value={formData.email}
                            onChange={handleChange}
                            className="mt-1 w-full border border-gray-300 rounded-xl p-3 focus:ring-2 focus:ring-indigo-300 focus:border-indigo-400 outline-none"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            Contact number <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="tel"
                            name="contactNumber"
                            required
                            value={formData.contactNumber}
                            onChange={handleChange}
                            className="mt-1 w-full border border-gray-300 rounded-xl p-3 focus:ring-2 focus:ring-indigo-300 focus:border-indigo-400 outline-none"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            Profession / Title <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            name="profession"
                            required
                            value={formData.profession}
                            onChange={handleChange}
                            placeholder="e.g. Founder, Consultant, Executive"
                            className="mt-1 w-full border border-gray-300 rounded-xl p-3 focus:ring-2 focus:ring-indigo-300 focus:border-indigo-400 outline-none"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            Company name <span className="text-gray-400">(optional)</span>
                        </label>
                        <input
                            type="text"
                            name="companyName"
                            value={formData.companyName}
                            onChange={handleChange}
                            className="mt-1 w-full border border-gray-300 rounded-xl p-3 focus:ring-2 focus:ring-indigo-300 focus:border-indigo-400 outline-none"
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-gray-900 text-white py-4 rounded-xl font-semibold hover:bg-gray-800 transition disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {loading ? "Submitting..." : "Claim Your Free Trial"}
                    </button>
                </form>

                <p className="mt-6 text-sm text-gray-500 text-center">
                    By submitting, you agree to our{" "}
                    <a href="/termsconditions" className="text-indigo-600 underline">
                        Terms
                    </a>{" "}
                    and{" "}
                    <a href="/privacy" className="text-indigo-600 underline">
                        Privacy Policy
                    </a>
                    . <Link to="/" className="text-indigo-600 underline">Back to home</Link>
                </p>
            </div>
        </div>
    );
}